import { ProcessingJobStatus } from '../constants/processing-job.constants';
import { DocumentType } from '../constants/document-type.constants';

export class ProcessingJob {
  _id?: string;
  image?: any;
  outputRaw?: any;
  outputFiltered?: any;
  outputEdited?: any;
  documentType?: DocumentType;
  status?: ProcessingJobStatus;
  file?: string | any;
  company?: string | any;
  processedTo?: string | any;
  project?: string | any;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}
